import { OrderTypeFilter } from '@absg/nim-client-shared';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'nc-order-type-filter',
  templateUrl: './order-type-filter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})

export class OrderTypeFilterComponent {
  isNucleusOrderChecked = false;
  isExternalOrderChecked = false;
  @Output() selectedOrderTypeFilter = new EventEmitter<OrderTypeFilter>();
  @Input() set appliedOrderFilter(orderFilter: OrderTypeFilter) {
    if (orderFilter) {
      this.isExternalOrderChecked = orderFilter.isExternalOrder;
      this.isNucleusOrderChecked = orderFilter.isNucleusOrder;
    }
  }

  onFilterByNucleusOrderChanged(): void {
    this.onTabChange(true, false);
    this.emitSelectedOrderTypeFilter();
  }

  onFilterByExternalOrderChanged(): void {
    this.onTabChange(false, true);
    this.emitSelectedOrderTypeFilter();
  }

  emitSelectedOrderTypeFilter(): void {
    const orderTypeFilter = new OrderTypeFilter();
    orderTypeFilter.isNucleusOrder = this.isNucleusOrderChecked;
    orderTypeFilter.isExternalOrder = this.isExternalOrderChecked;
    this.selectedOrderTypeFilter.emit(orderTypeFilter);
  }

  private onTabChange(isNucleusOrder: boolean, isExternalOrder: boolean): void {
    this.isNucleusOrderChecked = isNucleusOrder;
    this.isExternalOrderChecked = isExternalOrder;
  }
}
